























import { ref, defineComponent } from '@nuxtjs/composition-api'

// Common
import { SEARCH_TYPES, NESTED_FACET_NAMES } from '@/common/static/search'
import { FACETNAMES } from '@/common/static/facets'

// Composables
import useFacets from '@/composables/search/useFacets'

// Components
import MinusSVG from '@/assets/images/search/facet-header-minus.svg?inline'
import PlusSVG from '@/assets/images/search/facet-header-plus.svg?inline'

export default defineComponent({
  components: {
    MinusSVG,
    PlusSVG,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    open: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const { mapToFacetName } = useFacets()

    const isOpen = ref(false)
    const toggleAccordion = () => {
      isOpen.value = !isOpen.value
    }

    // Close all facets by default except for categories
    if (props.open !== -1 || props.name === SEARCH_TYPES.CATEGORIES || props.name === NESTED_FACET_NAMES.other.key) {
      isOpen.value = true
    }

    return {
      FACETNAMES,
      isOpen,
      toggleAccordion,
      mapToFacetName,
    }
  },
})
